/**
 * Forms Section - Form element comparison
 *
 * Tests:
 * - Text inputs
 * - Selects
 * - Checkboxes
 * - Radio buttons
 * - Text areas
 */
export default function FormsSection({ theme }) {
  const isDark = theme === 'dark';

  return (
    <div className="space-y-8">
      <div>
        <h2 className={`text-2xl font-bold mb-2 ${isDark ? 'text-white' : 'text-gray-900'}`}>
          Form Elements
        </h2>
        <p className={`text-sm ${isDark ? 'text-gray-400' : 'text-gray-600'}`}>
          Current vs iOS-style form inputs
        </p>
      </div>

      {/* Text Inputs */}
      <div className="grid md:grid-cols-2 gap-8">
        <div>
          <div className={`text-xs font-semibold uppercase tracking-wider mb-4 ${
            isDark ? 'text-gray-400' : 'text-gray-500'
          }`}>
            Current Design
          </div>
          <div className="space-y-4">
            <div>
              <label className={`block text-sm font-medium mb-2 ${
                isDark ? 'text-gray-300' : 'text-gray-700'
              }`}>
                Vessel Name
              </label>
              <input
                type="text"
                placeholder="Enter vessel name"
                className={`w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 ${
                  isDark
                    ? 'bg-gray-800 border-gray-600 text-white placeholder-gray-400'
                    : 'bg-white border-gray-300 text-gray-900 placeholder-gray-400'
                }`}
              />
            </div>

            <div>
              <label className={`block text-sm font-medium mb-2 ${
                isDark ? 'text-gray-300' : 'text-gray-700'
              }`}>
                Equipment Type
              </label>
              <select className={`w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 ${
                isDark
                  ? 'bg-gray-800 border-gray-600 text-white'
                  : 'bg-white border-gray-300 text-gray-900'
              }`}>
                <option>Select type...</option>
                <option>Fire Equipment</option>
                <option>Navigation Equipment</option>
                <option>Safety Equipment</option>
              </select>
            </div>
          </div>
        </div>

        <div>
          <div className={`text-xs font-bold uppercase tracking-wider mb-4 ${
            isDark ? 'text-blue-400' : 'text-blue-600'
          }`}>
            iOS-Style (Enhanced)
          </div>
          <div className="space-y-4">
            <div>
              <label className={`block text-sm font-bold mb-2 ${
                isDark ? 'text-gray-200' : 'text-gray-800'
              }`}>
                Vessel Name
              </label>
              <input
                type="text"
                placeholder="Enter vessel name"
                className={`w-full px-4 py-3 border-2 rounded-xl font-medium focus:outline-none focus:ring-2 focus:ring-blue-500 shadow-sm focus:shadow-md transition-all ${
                  isDark
                    ? 'bg-gray-800 border-gray-600 text-white placeholder-gray-500'
                    : 'bg-white border-gray-300 text-gray-900 placeholder-gray-500'
                }`}
              />
            </div>

            <div>
              <label className={`block text-sm font-bold mb-2 ${
                isDark ? 'text-gray-200' : 'text-gray-800'
              }`}>
                Equipment Type
              </label>
              <select className={`w-full px-4 py-3 border-2 rounded-xl font-medium focus:outline-none focus:ring-2 focus:ring-blue-500 shadow-sm focus:shadow-md transition-all ${
                isDark
                  ? 'bg-gray-800 border-gray-600 text-white'
                  : 'bg-white border-gray-300 text-gray-900'
              }`}>
                <option>Select type...</option>
                <option>Fire Equipment</option>
                <option>Navigation Equipment</option>
                <option>Safety Equipment</option>
              </select>
            </div>
          </div>
        </div>
      </div>

      {/* Checkboxes and Radio */}
      <div className="grid md:grid-cols-2 gap-8">
        <div className="space-y-4">
          <h3 className={`text-base font-medium ${isDark ? 'text-gray-300' : 'text-gray-700'}`}>
            Current Checkboxes
          </h3>
          <label className="flex items-center gap-2">
            <input type="checkbox" className="w-4 h-4 text-blue-600 rounded focus:ring-2 focus:ring-blue-500" />
            <span className={`text-sm ${isDark ? 'text-gray-300' : 'text-gray-700'}`}>
              Equipment operational
            </span>
          </label>
          <label className="flex items-center gap-2">
            <input type="checkbox" className="w-4 h-4 text-blue-600 rounded focus:ring-2 focus:ring-blue-500" />
            <span className={`text-sm ${isDark ? 'text-gray-300' : 'text-gray-700'}`}>
              Maintenance current
            </span>
          </label>
        </div>

        <div className="space-y-4">
          <h3 className={`text-base font-bold ${isDark ? 'text-gray-200' : 'text-gray-800'}`}>
            iOS-Style Checkboxes
          </h3>
          <label className="flex items-center gap-3">
            <input type="checkbox" className="w-5 h-5 text-blue-600 rounded-md focus:ring-2 focus:ring-blue-500 shadow-sm" />
            <span className={`text-sm font-medium ${isDark ? 'text-gray-200' : 'text-gray-800'}`}>
              Equipment operational
            </span>
          </label>
          <label className="flex items-center gap-3">
            <input type="checkbox" className="w-5 h-5 text-blue-600 rounded-md focus:ring-2 focus:ring-blue-500 shadow-sm" />
            <span className={`text-sm font-medium ${isDark ? 'text-gray-200' : 'text-gray-800'}`}>
              Maintenance current
            </span>
          </label>
        </div>
      </div>
    </div>
  );
}
